import UploadPicker from 'components/UploadPicker/UploadPicker';

export default UploadPicker;
